import { render, staticRenderFns } from "./brandmall-header.vue?vue&type=template&id=cb9b03f0&scoped=true"
import script from "./brandmall-header.vue?vue&type=script&lang=js"
export * from "./brandmall-header.vue?vue&type=script&lang=js"
import style0 from "./brandmall-header.vue?vue&type=style&index=0&id=cb9b03f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9b03f0",
  null
  
)

export default component.exports